module.exports = __webpack_public_path__ + "static/img/wiseBrain03.08fdc74.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/wiseBrain03.png
// module id = uB2s
// module chunks = 1